import { Select as AntSelect } from "antd"
import type { ReactNode } from "react"
import type { DefaultOptionType } from "antd/es/select"
import type { Variant } from "antd/es/config-provider"
import type { SelectProps } from "antd"

type Props = {
	variant: Variant
	options: DefaultOptionType[]
	placement?: SelectProps["placement"]
	value?: string | number | null
	open?: boolean
	placeholder?: string
	className?: string
	allowClear?: boolean
	disabled?: boolean
	onChange?: (e: string | number) => void
	// Fires on every option click, even one that leaves `value` unchanged — unlike `onChange`,
	// which antd only fires on an actual value change. Needed when the displayed value can equal
	// an option without that option having been explicitly picked (e.g. an inherited value).
	onSelect?: (e: string | number) => void
	onOpenChange?: (arg: boolean) => void
	onSearch?: (value: string) => void
	showSearch?: boolean
	optionFilterProp?: SelectProps["optionFilterProp"]
	renderInPlace?: boolean
	suffixIcon?: ReactNode
	notFoundContent?: ReactNode
}

export const Select = ({
	variant,
	options,
	placement = "bottomRight",
	value,
	placeholder,
	className,
	allowClear = false,
	disabled = false,
	onChange,
	onSelect,
	onOpenChange,
	onSearch,
	showSearch = false,
	optionFilterProp,
	renderInPlace = false,
	suffixIcon,
	notFoundContent,
}: Props) => {
	return (
		<div data-testid="select">
			<AntSelect
				style={{ width: "100%" }}
				disabled={disabled}
				placeholder={placeholder}
				allowClear={allowClear}
				variant={variant}
				options={options}
				placement={placement}
				value={value}
				onChange={onChange}
				onSelect={onSelect}
				onOpenChange={onOpenChange}
				onSearch={onSearch}
				className={className}
				showSearch={showSearch}
				optionFilterProp={optionFilterProp}
				suffixIcon={suffixIcon}
				notFoundContent={notFoundContent}
				getPopupContainer={renderInPlace ? (trigger) => trigger.parentElement! : undefined}
			/>
		</div>
	)
}
